import classNames from 'classnames';
import { BookOpen } from 'lucide-react';
import type { JSX } from 'react';
import { useSearchOwnDocs } from '../../agent/search-own-docs';
import { Button } from '../../components/Button/Button';
import { useTenantFeatures } from '../../hooks/useTenantFeatures';
import { TenantFeature } from '../../types/tenant.types';
import styles from './OwnDocsToggle.module.css';

/**
 * "Your docs", beside the attach button: when on, every message asks the assistant to search the
 * workspace's own help articles first. Shown only in workspaces with Support, which is where the
 * articles live. Off by default and reset by a new chat (agent/search-own-docs.ts).
 */
export function OwnDocsToggle(): JSX.Element | null {
  const { hasFeature } = useTenantFeatures();
  const [on, setOn] = useSearchOwnDocs();
  if (!hasFeature(TenantFeature.SUPPORT)) return null;
  const label = on ? 'Searching your docs. Turn off' : 'Search your docs';
  return (
    <Button
      type="button"
      variant="ghost"
      className={classNames(styles.Toggle, { [styles.ToggleOn]: on })}
      aria-pressed={on}
      aria-label={label}
      title={label}
      onClick={() => setOn(!on)}
    >
      <BookOpen aria-hidden="true" />
    </Button>
  );
}

export default OwnDocsToggle;
